import { getHiddenDataString, getWavesUserEmail } from '../hidden-data-provider';
import { ICartData, ICartItem } from '../../projects/shopping-cart/cart-bridger-pay/interfaces';
import { IOrder } from '../../projects/shopping-cart/cart-thank-you/interfaces';
import { getGdprCookie } from '../../projects/gdpr/domain/gdpr-provider';

/**
 * Allows to TypeScript recognize TikTok namespace
 */
declare global {
    interface Window {
        ttq: any;
        tiktokProductPagesViewContent: any;
    }
}

/**
 * add to cart
 */
export const tiktokAddToCart = (cartData: ICartData) => {

    if(!window.ttq ||
        !cartData.addedProductSKUID ||
        !cartData.cartItems) return;

    const cartItem = cartData.cartItems.find((item => item.skuid === cartData.addedProductSKUID));
    if(!cartItem) return;

    window.ttq.identify({
        email: cartData.email, // Will be auto-hashed before sending
    });

    window.ttq.track('AddToCart', {
        content_id: cartItem.skuNumber,
        content_type: 'product',
        content_name: cartItem.skuName,
        content_category: cartItem.departmentName, // (product category: plugins, bundles, etc...)
        quantity: 1,
        price: cartItem.skuPrice,
        value: cartData.priceData.totalPrice,
        currency: 'USD',
    });
};

export const tiktokAddToCartPopup = (cartItem: ICartItem) => {

    if(!window.ttq || !cartItem) return;

    window.ttq.identify({
        email: getWavesUserEmail(), // Will be auto-hashed before sending
    });

    window.ttq.track('AddToCart', {
        content_id: cartItem.skuNumber,
        content_type: 'product',
        content_name: cartItem.skuName,
        content_category: cartItem.departmentName, // (product category: plugins, bundles, etc...)
        quantity: 1,
        price: cartItem.skuPrice,
        value: cartItem.skuPrice,
        currency: 'USD',
    });
};

/**
 * lead
 */
export const tiktokLead = () => {
    if(!window.ttq) return;
    window.ttq.track('Subscribe');
};

export const tiktokCreateAccount = () => {
    if(!window.ttq) return;
    window.ttq.track('CompleteRegistration');
};

export const tiktokProductPagesViewContent = () => {
    if(!window.ttq) return;

    const jsonString = getHiddenDataString('efs-data');
    let json = null;

    try{
        json = JSON.parse(jsonString);
    }
    catch(ex){}

    if(!json || !Array.isArray(json) || json.length <= 0) return;

    const product = json[0];
    if(product.skuNumber && product.skuPrice > 0){

        window.ttq.track('ViewContent', {
            content_id: product.skuNumber,
            content_type: 'product',
            content_name: product.documentName,
            content_category: product.departmentID,
            quantity: 1,
            price: product.skuPrice,
            currency: 'USD',
            value: product.skuPrice,
        });
    }
};

export const sendTiktokPurchase = (eventName: string, orderData: IOrder) => {
    if(!window.ttq || !eventName || !orderData.orderItems?.length) return;

    const totalPrice = orderData.totalPrice; // cartData.priceData.totalPrice;

    const orderItems:  {
        content_id: string;
        content_name: string;
        content_type: string;
    }[] = [];

    for(const item of orderData.orderItems){

        orderItems.push({
            content_id: item.skuNumber,
            content_name: item.orderItemSKUName,
            content_type: 'product',
        });
    }

    window.ttq.track(eventName, {
        contents: orderItems,
        value: totalPrice,
        currency: 'USD',
    });
};

/**
 * TikTok's Pixel performs SHA-256 hashing in the browser before the identifier is sent to TikTok's servers.
 * You do not need to SHA-256 it yourself.
 * https://ads.tiktok.com/resources/help/article/advanced-matching-web
 */
export const sendTiktokIdentify = (email: string, phone?: string) => {
    if(!window.ttq) return;

    window.ttq.identify({
        email, // Will be auto-hashed before sending
        phone_number: phone ?? undefined, // Must be digits only with country code
    });
};

export const sendTiktokInitiateCheckout = (cartData: ICartData) => {
    if(!window.ttq) return;

    const gdpr = getGdprCookie();
    const isMarketing = gdpr.IsMarketing;
    if(!isMarketing) return;

    const totalPrice = cartData.priceData.totalPrice;
    if(!totalPrice) return;

    const activeItems: {
        content_id: string;
        content_name: string;
        content_type: string;
    }[] = [];

    for(const item of cartData.cartItems){
        if(!item.isActive) continue;

        activeItems.push({
            content_id: item.skuNumber,
            content_name: item.skuName,
            content_type: 'product',
        });
    }

    if(!activeItems.length) return;

    window.ttq.identify({
        email: cartData.email, // Will be auto-hashed before sending
    });

    window.ttq.track('InitiateCheckout',{
        contents: activeItems,
        value: totalPrice,
        currency: 'USD',
    });

};
